import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  IPostCompanyBusinessDocumentsParams,
  TPostCompanyBusinessDocumentsResponse,
} from "./postCompanyBusinessDocuments.schema";

export const postCompanyBusinessDocuments = (axios: IAxiosInstance) => {
  return async (
    params: IPostCompanyBusinessDocumentsParams
  ): Promise<TPostCompanyBusinessDocumentsResponse> => {
    const {
      companyID,
      ein_letter,
      additional_documents,
      authorized_agent_authorization,
    } = params;
    const formData = new FormData();
    if (ein_letter) {
      formData.append("ein_letter", ein_letter);
    }
    additional_documents.forEach((document) => {
      formData.append("additional_documents", document);
    });
    if (authorized_agent_authorization) {
      formData.append(
        "authorized_agent_authorization",
        authorized_agent_authorization
      );
    }

    const response = await axios.noRetry.post<
      IApiResponse<TPostCompanyBusinessDocumentsResponse>
    >(`/api/companies/${companyID}/business-documents`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const resData = response.data;
    if (resData?.data?.success) {
      return {
        success: true,
        message: resData.data?.message,
      };
    }
    throw new Error("Something went wrong");
  };
};
